module.exports = __webpack_public_path__ + "static/media/Logotype.34d286e6.svg";